'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate from "./app.api.-Pharmacy-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed(id) {
  this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed__f_id = null;
  this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed__f_id = id;
}
export { $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed as $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed };
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype = new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate.$h_Lapp_api_PharmacyAppUpdate();
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed() {
}
export { $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed as $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed };
$h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype;
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 893244976, true);
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed)) {
    var x = this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed__f_id;
    var x$2 = x$0.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed__f_id;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.productPrefix__T = (function() {
  return "AcceptedDrugRequestProcessed";
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed__f_id;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed.prototype.ordinal__I = (function() {
  return 7;
});
function $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed)));
}
export { $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed as $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed };
var $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed, "app.api.PharmacyAppUpdate$AcceptedDrugRequestProcessed", ({
  Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed: 1,
  Lapp_api_PharmacyAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed as $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestProcessed };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Accepted-Drug-Request-Processed.js.map
